<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>角色特权 / {{ roleId ? "编辑" : "新增" }}</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form label-width="120px" label-position="left" ref="ruleForm" :rules="formRules" :model="formData">
            <el-form-item label="角色名称" prop="name">
               <el-input v-model="formData.name" placeholder="最多20个字符" :maxlength="20" />
            </el-form-item>
            <el-form-item label="角色标志" prop="logo">
               <UploadImage keys="logo" :urls="formData.logo" @onUrls="onUrls" tips="80~200 × 80，格式为jpg、png、gif" />
            </el-form-item>
            <el-form-item label="发视频动态权限">
               <el-switch v-model="formData.videoEnabled" on-text off-text></el-switch>
            </el-form-item>
            <el-form-item label="免除广告权限">
               <el-switch v-model="formData.advertisingEnabled" on-text off-text></el-switch>
            </el-form-item>
            <el-form-item label="后台创作权限">
               <el-switch v-model="formData.creationEnabled" on-text off-text></el-switch>
            </el-form-item>
            <el-form-item label="核心主题" v-if="roleId">
               <el-select placeholder="请选择核心主题" v-model="formData.coreTheme">
                  <el-option v-for="(item, index) in coreThemeOptions" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="欢迎图">
               <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=6" keys="homePicture"
                  :urls="formData.homePicture" @onUrls="onUrls" tips="支持jpg、png、gif">
               </UploadImage>
            </el-form-item>
            <el-form-item label="续费图" prop="renewUrl">
               <UploadImage keys="renewUrl" :urls="formData.renewUrl" @onUrls="onUrls" tips="支持jpg、png、gif" />
            </el-form-item>
         </el-form>
      </div>

      <div class="margin-20">
         <el-button @click="handleSave(1)">保存</el-button>
         <el-button type="primary" @click="handleSave(2)">保存并上架</el-button>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";

export default {
   components: {
      UploadImage
   },

   data() {
      return {
         loading: false,
         formData: {
            name: "", // 角色名称
            logo: "", // 标志
            videoEnabled: false, // 发视频动态权限(0:开启，1：关闭)
            advertisingEnabled: false, // 免除广告权限(0:开启，1：关闭)
            creationEnabled: false, // 后台创作权限(0:开启，1：关闭)
            coreTheme: 0, // 核心主题
            homePicture: '', // 欢迎图
            renewUrl: '', // 续费图地址
         },
         formRules: {
            name: [
               { required: true, message: "请输入角色名称", trigger: "blur" },
               { min: 0, max: 20, message: "最多20个字", trigger: "blur" }
            ],
            logo: [{ required: true, message: "请上传角色标志", trigger: "change" }],
            renewUrl: [{ required: true, message: "请上传续费图", trigger: "blur" }],
         },
         roleId: "",
         coreThemeOptions: [],
      }
   },

   mounted() {
      if (this.$route.query.option) {
         const option = JSON.parse(decodeURIComponent(this.$route.query.option));
         if (option && JSON.stringify(option) !== "{}") {
            this.roleId = option.roleId;
            this.apiGetPrivilegeDetail();
         }
      }
   },

   methods: {
      // 获取详情
      async apiGetPrivilegeDetail() {
         try {
            this.loading = true;
            const result = await this.$http({
               url: this.$util.domain + "/adminapi/privilege/v1/detail",
               method: "GET",
               params: {
                  roleId: this.roleId
               }
            });
            if (result.body.data && JSON.stringify(result.body.data) !== "{}") {
               this.formData = Object.assign({}, result.body.data, {
                  videoEnabled: result.body.data.videoEnabled === 0 ? true : false,
                  advertisingEnabled:
                     result.body.data.advertisingEnabled === 0 ? true : false,
                  creationEnabled:
                     result.body.data.creationEnabled === 0 ? true : false,
               });
               this.queryCoreTheme(result.body.data.id);
            } else {
               this.formData = {};
               result.body.message && this.$message.error(result.body.message);
            }
         } catch (error) {
            this.formData = {};
         } finally {
            this.loading = false;
         }
      },
      // 获取核心主题
      queryCoreTheme(id) {
         let params = {
            priId: id,
            businessType: 1,
         };
         this.$http({
            url: this.$util.domain + '/adminapi/v1/personalizedComponents/userType',
            method: 'GET',
            params: params
         }).then((res) => {
            const content = res.data.data || [];
            this.coreThemeOptions = content.map((item) => ({
               label: item.name,
               value: item.id
            }));
         }).catch((err) => {
            this.coreThemeOptions = [];
         })
      },
      // 图片上传成功
      onUrls(urls, keys) {
         this.formData[keys] = urls;
      },
      // 保存，type 1:保存 2：保存并发布
      handleSave(type) {
         this.$refs.ruleForm.validate(async valid => {
            if (!valid) {
               return false;
            }
            try {
               if (type === 2) {
                  const data = await this.$confirm("是否确认发布？", "", {
                     cancelButtonText: "取消",
                     confirmButtonText: "确定"
                  });
                  if (data !== "confirm") {
                     return false;
                  }
               }
               const params = {
                  ...this.formData,
                  videoEnabled: this.formData.videoEnabled ? 0 : 1,
                  advertisingEnabled: this.formData.advertisingEnabled ? 0 : 1,
                  creationEnabled: this.formData.creationEnabled ? 0 : 1,
                  type
               };
               const result = await this.$http({
                  method: "POST",
                  url: this.$util.domain + "/adminapi/privilege/v1/addOrEdit",
                  body: JSON.stringify({
                     ...params
                  })
               });
               if (result.body.error == 10000) {
                  this.$message({
                     type: "success",
                     message: "操作成功!"
                  });
                  this.$router.go(-1);
               } else {
                  this.$message({
                     type: "error",
                     message: result.message
                  });
               }
            } catch (error) {
               this.$message({
                  type: "error",
                  message: error.message
               });
            }
         });
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// PrivilegeRoleDetail.vue?0a8bc29b